import styled from 'styled-components';
import { KakaoEmphasizeType } from '../../api/kakaoTemplate';

const Group = styled.fieldset`
  min-width: 0; max-width: 620px; margin: 0 0 24px; padding: 0; border: 0;
  legend { margin-bottom: 12px; padding: 0; color: ${({ theme }) => theme.color.text_color_100}; font-size: 14px; font-weight: 600; }
`;
const Grid = styled.div`display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 14px;`;
const Card = styled.label<{ $selected: boolean }>`
  position: relative; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 11px;
  min-height: 174px; padding: 22px 22px 18px; box-sizing: border-box; border-radius: 8px; cursor: pointer;
  border: 2px solid ${({ theme, $selected }) => $selected ? theme.color.point_y_100 : theme.color.primary_300};
  background: ${({ theme }) => theme.color.primary_50};
  color: ${({ theme, $selected }) => $selected ? theme.color.point_y_100 : theme.color.text_color_100};
  box-shadow: ${({ $selected }) => $selected ? '0 2px 8px #00000014' : 'none'};
  strong { font-size: 17px; font-weight: ${({ $selected }) => $selected ? 700 : 500}; }
  &:hover { border-color: ${({ theme }) => theme.color.point_y_100}; }
  &:focus-within { outline: 2px solid ${({ theme }) => theme.color.point_y_100}; outline-offset: 2px; }
  @media (max-width: 700px) { min-height: 148px; padding: 16px 10px 12px; strong { font-size: 15px; } }
`;
const Radio = styled.input`
  position: absolute; top: 14px; right: 14px; width: 22px; height: 22px; margin: 0;
  appearance: none; border: 2px solid ${({ theme }) => theme.color.text_color_300}; border-radius: 50%;
  background: transparent; cursor: pointer;
  &:checked { border-color: ${({ theme }) => theme.color.point_y_100}; background: ${({ theme }) => theme.color.point_y_100};
    box-shadow: inset 0 0 0 4px ${({ theme }) => theme.color.primary_50}; }
  &:focus-visible { outline: 2px solid ${({ theme }) => theme.color.point_y_100}; outline-offset: 2px; }
`;
const MiniMessage = styled.div`
  width: 106px; height: 73px; box-sizing: border-box; padding: 0 10px 8px;
  background: #FFFFFF; border: 1px solid #E2E5E9; overflow: hidden;
  &::before { content: ''; display: block; height: 10px; margin: 0 -10px 8px; background: #FEE500; }
`;
const Line = styled.span<{ $width: string; $heavy?: boolean }>`
  display: block; width: ${({ $width }) => $width}; height: ${({ $heavy }) => $heavy ? 5 : 4}px;
  margin: 4px 0; background: ${({ $heavy }) => $heavy ? '#70757B' : '#B6BAC0'};
`;
const ImageBlock = styled.span`
  display: grid; place-items: center; width: 25px; height: 22px; float: right; margin-top: 2px;
  background: #D5E8F9; color: #3977C3; font-size: 13px;
`;
const MiniRows = styled.div`
  display: grid; grid-template-columns: 1fr 1fr; gap: 5px;
  span { display: block; height: 5px; background: #A3A8AE; }
  span:nth-child(3), span:nth-child(4) { background: #CFD3D7; }
`;

const choices: Array<{ type: KakaoEmphasizeType; label: string }> = [
  { type: 'NONE', label: '기본형' }, { type: 'TEXT', label: '강조표기형' },
  { type: 'IMAGE', label: '이미지첨부형' }, { type: 'ITEM_LIST', label: '리스트형' },
];

function Thumbnail({ type }: { type: KakaoEmphasizeType }) {
  return <MiniMessage aria-hidden="true">
    {type === 'NONE' && <><Line $width="75%" /><Line $width="56%" /><Line $width="60%" /></>}
    {type === 'TEXT' && <><Line $width="48%" /><Line $width="72%" $heavy /><Line $width="80%" /><Line $width="59%" /></>}
    {type === 'IMAGE' && <><ImageBlock>▧</ImageBlock><Line $width="51%" /><Line $width="38%" /><Line $width="44%" /></>}
    {type === 'ITEM_LIST' && <MiniRows><span /><span /><span /><span /><span /><span /></MiniRows>}
  </MiniMessage>;
}

export default function KakaoTemplateTypeSelector({ value, onChange }: {
  value: KakaoEmphasizeType; onChange: (value: KakaoEmphasizeType) => void;
}) {
  return <Group>
    <legend>템플릿 유형</legend>
    <Grid>{choices.map(choice => <Card key={choice.type} $selected={value === choice.type}>
      <Radio type="radio" name="kakao-emphasize-type" value={choice.type} checked={value === choice.type} onChange={() => onChange(choice.type)} />
      <Thumbnail type={choice.type} /><strong>{choice.label}</strong>
    </Card>)}</Grid>
  </Group>;
}
